import React, { useEffect, useRef } from 'react';
import MessageItem from './MessageItem';
import WelcomeCard from './WelcomeCard';
import '../styles/MessageList.css';

const MessageList = ({ messages, onSuggestionClick, lastAssistantMessageIndex, hasUserStartedChat }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  // Mostrar bienvenida solo si el usuario no ha iniciado el chat y no hay mensajes
  const showWelcome = !hasUserStartedChat && messages.length === 0;

  if (showWelcome) {
    return (
      <div className="message-list">
        <WelcomeCard />
      </div>
    );
  }

  if (messages.length === 0) {
    return (
      <div className="message-list empty-state">
        <div className="empty-state-content">
          <div className="empty-state-icon">💬</div>
          <h3>Inicia una conversación</h3>
          <p>Escribí tu consulta o seleccioná una de las acciones rápidas para comenzar a analizar datos técnicos con IA</p>
        </div>
      </div>
    );
  }

  return (
    <div className="message-list">
      {messages.map((message, index) => (
        <MessageItem
          key={message.id}
          message={message}
          onSuggestionClick={onSuggestionClick}
          isLastAssistantMessage={index === lastAssistantMessageIndex}
        />
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
